import { Box, ModalBackdropStyled, SideSheetHeader, SideSheetClose, ButtonAppearance, Button } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { listWidth, smallScreenListWidth } from '../../styled';
import { ListSelectionStyled } from '@bechtel/client-common';

export const DrawerBackdropStyled = styled(ModalBackdropStyled)`
  position: absolute;
  left: ${listWidth};

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    left: ${smallScreenListWidth};
  }
`;
export const DrawerOuterStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  height: 100%;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: ${listWidth};
`;

export const DrawerFilterHeaderStyled = styled(Box).attrs({
  pl: { sm: '500' },
  pb: { sm: '500' },
  pt: { sm: '600' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[200]};
    border-bottom: 1px solid ${theme.colors.grey[300]};
    font-size: ${theme.fontSizes[400]};
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.grey[1000]};
  `}
`;

export const DrawerSubHeaderStyled = styled(Box).attrs({
  py: { sm: '500' },
  pl: { sm: '500' },
  pr: { sm: '500' },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'space-between' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[100]};
    border-bottom: 1px solid ${theme.colors.grey[300]};
    font-size: ${theme.fontSizes[400]};
    color: ${theme.colors.grey[1000]};
  `}
`;

export const ListSelectionHeadingStyled = styled(ListSelectionStyled)`
  background-color: ${({ theme }) => theme.colors.grey[100]};
`;

export const DateListSelectionStyled = styled(ListSelectionStyled)`
  flex-direction: column;
  justify-content: space-between;
  align-items: baseline;
  padding-right: ${({ theme }) => theme.spacings[400]};
`;
export const DrawerHeader = styled(SideSheetHeader).attrs({ title: 'Filters' })`
  ${({ theme }) =>
    css`
      background-color: ${theme.colors.white};
      color: ${theme.colors.grey[1000]};
    `}
`;

export const DrawerClose = styled(SideSheetClose).attrs({ appearance: ButtonAppearance.SECONDARY })`
  ${({ theme }) =>
    css`
      color: ${theme.colors.blue[800]};
      border: none;
    `}
`;

export const DrawerFooterButtonStyled = styled(Button)`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.bechtel.blue[800]};
  `}
`;
